enum TemplateNews {
  TEMPLATE_UM = 'template_1'
}

export default TemplateNews;
